<template lang="pug">
  #init-view.body: .body-inner
    TheBigLoader(v-if="loader")
    .error-msg(v-if="errorMsg.length > 0")
      i: UiIcon(icon="surprise-emo")
      p(v-text="errorMsg")
</template>

<script>
import TheBigLoader from '@/layouts/TheBigLoader'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Init',
  // Components ----------------------------------------------------------------
  components: {
    TheBigLoader
  },
  // Created ------------------------------------------------------------ [Hook]
  created () {
    this.SET_CURRENT_VIEW({ vm: null })
  },
  // Mounted ------------------------------------------------------------ [Hook]
  mounted () {
    this.init()
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      loader: true,
      errorMsg: ''
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Security SM
    ...mapGetters('moduleSecurity', [
      'hasParentFrame'
    ])
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map actions of the Root
    ...mapActions([
      'getAppCurrentHeight'
    ]),
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_CURRENT_VIEW'
    ]),
    // Vuex map mutations of the Security SM
    ...mapMutations('moduleSecurity', [
      'UNSET_MESSAGE_CALLBACK'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage',
      'appVerify'
    ]),
    // Init
    async init () {
      // If parent frame does not exist
      if (!this.hasParentFrame) {
        this.loader = false
        this.errorMsg = 'Ошибка #424'
        return
      }
      this.sendMessage({
        h: await this.getAppCurrentHeight(),
        l: true, // send back parent location
        t: true, // send back parent config
        callback: this.verify
      })
    },
    // Verify
    verify () {
      this.UNSET_MESSAGE_CALLBACK() // unset the callback
      setTimeout(async () => {
        const { status, errors } = await this.appVerify()
        if (status) {
          this.$router.push({ name: 'initials' })
        } else {
          this.loader = false
          this.errorMsg = errors.global[0]
        }
      }, 1000)
    }
  }
}
</script>
